import {
  IAnalyticsEventScratchpadProperties,
  IAnalyticsScratchpadArgument,
} from './types';
import { getCreator } from '../user/utils';

export const getScratchpadEventProperties = (
  scratchpad: IAnalyticsScratchpadArgument,
): IAnalyticsEventScratchpadProperties => {
  return {
    object_type: 'scratchpad',
    object_id: scratchpad.id,
    object_name: scratchpad.title,
    object_owner: getCreator(scratchpad),
  };
};
